"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _excluded = ["className"];
/*:: type Props = {
  className?: string
};*/
/**
 * A simple wrapper to apply `ListItem` styles to an svg icon.
 */
function ListItemIcon(_ref /*:: */) {
  var className = _ref /*:: */.className,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    className: className
  }, props));
}
ListItemIcon.displayName = 'ListItemIcon';
var _default = exports.default = ListItemIcon;
//# sourceMappingURL=ListItemIcon.js.map